export default {
  'ACCESS_TOKEN': 'Auth.accessToken',
  'DECODED_TOKEN': 'Auth.decodedToken',
  'XSRF_TOKEN': 'Auth.xsrfToken',
  'AUTH_STYLE': 'Auth.authStyle'
}
